import React from 'react';
import { ListItem, ListItemText, MenuItem, Menu } from '@material-ui/core';
import { connect } from 'react-redux';
import * as DevToolActions from 'app/actions/dev-tool/actions';

interface FinicityTestCase {
  dateOfBirth           : string;
  ssn                   : string;
}

const homerLoanSeeke: FinicityTestCase = {
  dateOfBirth : '07-04-1970',
  ssn         : '999-60-1111',
};

const jessSea: FinicityTestCase = {
  dateOfBirth : '07-05-1980',
  ssn         : '999-00-1147',
};

const annSea: FinicityTestCase = {
  dateOfBirth : '07-06-1986',
  ssn         : '999-00-9066',
};

const aliceFirsttimer: FinicityTestCase = {
  dateOfBirth : '12-27-1992',
  ssn         : '991-91-9991',
};

const lorrainePurchaser: FinicityTestCase = {
  dateOfBirth : '05-02-1985',
  ssn         : '999-56-5678',
};

const patrick: FinicityTestCase = {
  dateOfBirth : '09-09-1987',
  ssn         : '999-12-1234',
};

const andy: FinicityTestCase = {
  dateOfBirth : '05-05-1980',
  ssn         : '881-11-0010',
};

const andyFreddie: FinicityTestCase = {
  dateOfBirth : '08-06-1990',
  ssn         : '990-30-0003',
};

const dan: FinicityTestCase = {
  dateOfBirth : '08-02-1970',
  ssn         : '991-00-0010',
};

const patrickFreddie = {
  dateOfBirth : '08-09-1980',
  ssn         : '990-50-0005',
};

const amyFreddie = {
  dateOfBirth : '08-07-1980',
  ssn         : '990400004',
};

const suziFreddie = {
  dateOfBirth : '08-06-1990',
  ssn         : '990-70-0007',
};

const momFreddie = {
  dateOfBirth : '08-04-1970',
  ssn         : '990-11-0011',
};

const aliceFreddie = {
  dateOfBirth : '08-05-1990',
  ssn         : '990-08-0008',
};

const johnFreddie = {
  dateOfBirth : '08-01-1970',
  ssn         : '990-10-0001',
};

const nomoniFreddie = {
  dateOfBirth : '01-01-2000',
  ssn         : '123-45-6788',
};

const nomulaFrannie = {
  dateOfBirth : '01-01-2000',
  ssn         : '123-45-6787',
};

const options = [
  { label: 'No Test Case Selected', value: {} },
  { label: 'Homer Loanseeke - 1 active employment; salary, base', value: homerLoanSeeke },
  { label: 'Jess Sea - 1 active employment; salary, base', value: jessSea },
  { label: 'Ann Sea - 1 active employment; commission only', value: annSea },
  { label: 'Alice Firstimer - 1 active employment; salary, base + overtime', value: aliceFirsttimer },
  { label: 'Lorraine Purchaser - 1 active employment; hourly, base', value: lorrainePurchaser },
  { label: 'Patrick Purchased - 1 active employment; hourly, base', value: patrick },
  { label: 'Andy Miller - 1 active employment; salary', value: andy },
  { label: 'Andy Freddie - 1 active employment; salary, base + bonus + overtime + commissions, 1 terminated employment', value: andyFreddie },
  { label: 'Dan Freddie - 1 active employment; salary, base + bonus', value: dan },
  { label: 'Patrick Freddie - 1 active employment; base, semi-monthly, salary', value: patrickFreddie },
  { label: 'Amy Freddie - 1 active employment; base + bonus, bi-weekly, salary', value: amyFreddie },
  { label: 'Suzi Freddie - 2 active employments; base; semi-monthly, monthly', value: suziFreddie },
  { label: 'Mom Freddie - 2 active employments; base + bonus + overtime + commissions, bi-weekly', value: momFreddie },
  { label: 'Alice Freddie - 1 terminated employment; base, semi-monthly', value: aliceFreddie },
  { label: 'John Freddie - 1 active employment w/ payroll; base + bonus + commission + overtime + weekly. Child support, military, VA benefits, alimony.', value: johnFreddie },
  { label: 'Nomoni Freddie - No payroll data (test 404 error)', value: nomoniFreddie },
  { label: 'Nomula Frannie - No payroll data (test 404 error)', value: nomulaFrannie },
];

class DevFinicityBorrower extends React.Component<any, any> {
  state = {
    anchorEl     : null,
    selectedIndex: 0,
  };

  handleClickListItem = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuItemClick = (event, index) => {
    this.setState({ selectedIndex: index, anchorEl: null });
    this.props.setFinicityTestCase(options[index].value, this.props.isCoBorrower);
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;
    const label = `Finicity Test Case ${this.props.isCoBorrower ? '(CoBorrower)' : '(Borrower)'}`;

    return (
      <React.Fragment>
        <ListItem
          button
          aria-haspopup = 'true'
          aria-controls = 'lock-menu'
          aria-label    = {label}
          onClick       = {this.handleClickListItem}
        >
          <ListItemText
            primary   = {label}
            secondary = {options[this.state.selectedIndex].label}
          />
        </ListItem>
        <Menu
          id       = 'lock-menu'
          anchorEl = {anchorEl}
          open     = {Boolean(anchorEl)}
          onClose  = {this.handleClose}
        >
          {options.map((option, index) => {
            return (
              <MenuItem
                disabled = {index === 0}
                key      = {option.label}
                onClick  = {event => this.handleMenuItemClick(event, index)}
                selected = {index === this.state.selectedIndex}
              >
                {option.label}
              </MenuItem>
            );
          })}
        </Menu>

      </React.Fragment>
    );
  }
}

const mapDispatchToProps = DevToolActions;

export default connect(null, mapDispatchToProps)(DevFinicityBorrower);
